module.exports = __webpack_public_path__ + "static/media/threestepicon2.bd80c843.png";